// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-color: #5e6ab2;
  --hover-bg: #f3f3f9;
  --text-color: #1a1a1a;
  --bg-color: #fcfcfc;
  --border-color: #e1e1e2;
  --border-blue: #bae0ff;
  --green-color: #149041;
  --red-color: #f4651f;
  --yellow-color: #FFB020;
  --error-color: #d1312c;
  --input-border-color: #e5e7eb;
  --input-asterisk-color: currentColor;
  --mantine-color-error: var(--mantine-color-red-6);
}

html,
body {
  color: var(--text-color);
}
@media screen and (min-width: 48em) {
  html,
  body {
    overflow: hidden;
  }
}
@media screen and (max-width: 47.99em) {
  html,
  body {
    overflow-x: hidden;
    overflow-y: auto;
  }
}

.custom-text-color {
  color: var(--text-color);
}

.custom-bg-color {
  background-color: var(--bg-color);
}

.custom-border-color {
  border-color: var(--border-color);
}

.custom-hover-border-color {
  border-color: var(--primary-color);
}

.btn-primary {
  background-color: var(--primary-color);
  height: 44px;
  border-radius: 6px;
  padding: 0 16px;
  color: white;
  transition: all 0.2s ease-in-out;
}

.btn-primary:hover {
  opacity: 0.9;
}

.custom-box-shadow {
  box-shadow: 0px 6px 16px 0px rgba(0, 0, 0, 0.08), 0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 9px 28px 8px rgba(0, 0, 0, 0.05);
}

@media screen and (max-width: 47.99em) {
  /* Ensure consistent mobile padding for auth pages */
  .signup-container {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }
  /* Prevent horizontal scrolling on mobile */
  body, html, #root {
    overflow-x: hidden;
    width: 100%;
    max-width: 100vw;
  }
  /* Ensure form containers don't exceed viewport width */
  .signup-container .mx-auto > div {
    max-width: calc(100vw - 2rem);
  }
  /* Improve touch interactions on mobile */
  input, button, select, textarea {
    font-size: 16px; /* Prevents zoom on iOS */
  }
  /* Ensure buttons are touch-friendly */
  button {
    min-height: 44px;
    touch-action: manipulation;
  }
}
@media screen and (max-height: 690px) {
  .signup-container {
    display: block;
    padding-top: 40px;
    padding-bottom: 40px;
  }
}
@media screen and (min-height: 690px) {
  .signup-container {
    height: calc(100vh - 70px);
    display: flex;
  }
  .signup-container.extend {
    height: calc(100vh - 120px);
  }
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,sBAAA;EACA,oBAAA;EACA,uBAAA;EACA,sBAAA;EACA,6BAAA;EACA,oCAAA;EACA,iDAAA;AACF;;AAEA;;EAEE,wBAAA;AACF;AACE;EAJF;;IAKI,gBAAA;EAGF;AACF;AADE;EARF;;IASI,kBAAA;IACA,gBAAA;EAKF;AACF;;AAFA;EACE,wBAAA;AAKF;;AAFA;EACE,iCAAA;AAKF;;AAFA;EACE,iCAAA;AAKF;;AAFA;EACE,kCAAA;AAKF;;AAFA;EACE,sCAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,gCAAA;AAKF;;AAFA;EACE,YAAA;AAKF;;AAFA;EACE,4HACE;AAIJ;;AACA;EACE,oDAAA;EACA;IACE,6BAAA;IACA,8BAAA;EAEF;EACA,2CAAA;EACA;IACE,kBAAA;IACA,WAAA;IACA,gBAAA;EACF;EAEA,uDAAA;EACA;IACE,6BAAA;EAAF;EAGA,yCAAA;EACA;IACE,eAAA,EAAA,yBAAA;EADF;EAIA,sCAAA;EACA;IACE,gBAAA;IACA,0BAAA;EAFF;AACF;AAKA;EACE;IACE,cAAA;IACA,iBAAA;IACA,oBAAA;EAHF;AACF;AAMA;EACE;IACE,0BAAA;IACA,aAAA;EAJF;EAOA;IACE,2BAAA;EALF;AACF","sourcesContent":[":root {\n  --primary-color: #5e6ab2;\n  --hover-bg: #f3f3f9;\n  --text-color: #1a1a1a;\n  --bg-color: #fcfcfc;\n  --border-color: #e1e1e2;\n  --border-blue: #bae0ff;\n  --green-color: #149041;\n  --red-color: #f4651f;\n  --yellow-color: #FFB020;\n  --error-color: #d1312c;\n  --input-border-color: #e5e7eb;\n  --input-asterisk-color: currentColor;\n  --mantine-color-error: var(--mantine-color-red-6);\n}\n\nhtml,\nbody {\n  color: var(--text-color);\n\n  @media screen and (min-width: 48em) {\n    overflow: hidden;\n  }\n  \n  @media screen and (max-width: 47.99em) {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n}\n\n.custom-text-color {\n  color: var(--text-color);\n}\n\n.custom-bg-color {\n  background-color: var(--bg-color);\n}\n\n.custom-border-color {\n  border-color: var(--border-color);\n}\n\n.custom-hover-border-color {\n  border-color: var(--primary-color);\n}\n\n.btn-primary {\n  background-color: var(--primary-color);\n  height: 44px;\n  border-radius: 6px;\n  padding: 0 16px;\n  color: white;\n  transition: all 0.2s ease-in-out;\n}\n\n.btn-primary:hover {\n  opacity: 0.9;\n}\n\n.custom-box-shadow {\n  box-shadow:\n    0px 6px 16px 0px rgba(0, 0, 0, 0.08),\n    0px 3px 6px -4px rgba(0, 0, 0, 0.12),\n    0px 9px 28px 8px rgba(0, 0, 0, 0.05);\n}\n\n@media screen and (max-width: 47.99em) {\n  /* Ensure consistent mobile padding for auth pages */\n  .signup-container {\n    padding-left: 1rem !important;\n    padding-right: 1rem !important;\n  }\n  \n  /* Prevent horizontal scrolling on mobile */\n  body, html, #root {\n    overflow-x: hidden;\n    width: 100%;\n    max-width: 100vw;\n  }\n  \n  /* Ensure form containers don't exceed viewport width */\n  .signup-container .mx-auto > div {\n    max-width: calc(100vw - 2rem);\n  }\n  \n  /* Improve touch interactions on mobile */\n  input, button, select, textarea {\n    font-size: 16px; /* Prevents zoom on iOS */\n  }\n  \n  /* Ensure buttons are touch-friendly */\n  button {\n    min-height: 44px;\n    touch-action: manipulation;\n  }\n}\n\n@media screen and (max-height: 690px) {\n  .signup-container {\n    display: block;\n    padding-top: 40px;\n    padding-bottom: 40px;\n  }\n}\n\n@media screen and (min-height: 690px) {\n  .signup-container {\n    height: calc(100vh - 70px);\n    display: flex;\n  }\n\n  .signup-container.extend {\n    height: calc(100vh - 120px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
